import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { TextBox, formatDate, formatTime } from "../../Components/InputElements";
import { decodeData } from "../../Constants/constants";
class OTSummaryReport extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {

      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      location_id: "",
      department_id: "",
      Department: [],
      Location: [],
      Department: [],
      Location: [],
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      selectedEmployeeId: null,
      selectedRows: [],
      decodedData: [],

    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetDepartmentMasters();
      this.GetLocationMasters();

    });
  }
  componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
  }
  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Attendance/GetEmployeeAttendance?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      console.log(`data`, data);
      if (success === true) {
        this.setState(
          {
            employee_name: data[0].employee_name,
            employee_mobile_number: data[0].employee_mobile_number,
            employee_email_address: data[0].employee_email_address,
            employee_gender: data[0].employee_gender,
            employee_joining_date: data[0].employee_joining_date,
            designation_id: data[0].designation_id,
            department_id: data[0].department_id,
            grade_id: data[0].grade_id,
            location_id: data[0].location_id,
            employee_address: data[0].employee_address,
            reporting_manager_id: data[0].reporting_manager_id,
            blood_Group: data[0].blood_group,
            From_date: data[0].employee_from_date,
            To_date: data[0].employee_from_to,
            Date_of_birth: data[0].date_of_birth,
            Title: data[0].employee_title,
            company_employee_category_id: data[0].employee_category,
            company_employee_type_id: data[0].employee_type,
            permanent_Address: data[0].employee_permanent_address,
            pinCode: data[0].pin_code,
            enter_State: data[0].employee_state,
          }
        )
      }
    });
  }

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };



  GetList = () => {
    if(this.state.from_date && this.state.to_date){}else{
      return false;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    var params = {
      limit: this.state.limit,
      page: this.state.page??1,
      keyword: this.state.keyword,
      from_date: this.state.from_date,
      to_date: this.state.to_date,
      employee_id: this.state.employee_id,
      location_id: this.state.location_id,
      department_id: this.state.department_id,
    };
    console.log("params", params)
    axios
      .get(`${apiURL}Attendance/GetEmployeeOTReport`, {
        params: params,
        headers,
      })
      .then((response) => {
        var data = response.data;
        console.log("selmonbhai", data);
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  showAll = () =>{
    this.setState({limit: this.state.total_records}, () => {
      this.GetList();
    })
  }
  // handleClearAll = () => {
  //   this.setState({
  //     employee_id: 0,
  //     rows: [],
  //     next: false,
  //     prev: false,
  //     page: 1,
  //     limit: 10,
  //     total_records: 0,
  //     total_pages: 0,
  //     loadingList: false,
  //     postLoading: false,
  //     keyword: "",
  //     from_date: "",
  //     to_date: "",
  //     selectOption: "",
  //   }
  //     , () => {
  //       this.GetList();
  //     });
  // };

  handleSelectStatus = (selectedOption) => {

    this.setState({ selectOption: selectedOption.value, });
  };

  handleDepartmentChange = (selectedOption) => {
    this.setState({
      department_id: selectedOption.value,
    });
  };

  handleLocationChange = (selectedOption) => {
    this.setState({
      location_id: selectedOption.value,
    });
  };

  handleSelectType = (selectedOption) => {
    this.setState({ filter_leave_type_id: selectedOption.value, });
  };

  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };
   getDuration = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    // Calculate the difference in milliseconds
    const durationMs = end - start;

    // Convert milliseconds to human-readable format
    const milliseconds = durationMs % 1000;
    let seconds = Math.floor((durationMs / 1000) % 60);
    let minutes = Math.floor((durationMs / (1000 * 60)) % 60);
    let hours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
    const days = Math.floor(durationMs / (1000 * 60 * 60 * 24));

    // Add leading zeros if necessary
    seconds = seconds < 10 ? "0" + seconds : seconds;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    hours = hours < 10 ? "0" + hours : hours;

    return hours;
}

  render() {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`OT Report`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-2'>
                        <label htmlFor="keyword">Enter keyword</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                        </div>
                      </div>
                      <div className='col-md-2'>
                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                      </div>
                      <div className='col-md-2'>
                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                      </div>
                      <div className="col-md-2 ">

                        <label htmlFor="Department" className="form-label" > Department </label>
                        <Select
                          value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null}
                          options={this.state.Department}
                          onChange={this.handleDepartmentChange}
                          hint={`Select Department`}
                        />
                      </div>

                      <div className="col-md-2 ">
                        <label htmlFor="Location" className="form-label" > Location </label>
                        <Select
                          value={this.state.location_id ? this.state.Location.find(option => option.value === this.state.location_id) : null}
                          options={this.state.Location}
                          onChange={this.handleLocationChange}
                          hint={`Select Location`}
                        />
                      </div>
                      <div className='col-md-1' >
                            <div>
                              <label>Apply Filter</label>
                            </div>
                            <button
                              type="button"
                              onClick={this.handleInputSearch}
                              // disabled={this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === ''}
                              className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                              <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                              Filter
                            </button>
                          </div>
                    </div>
                    <div className="row mt-3">
                      <div className='col-md-12' >
                        <div className="row">

                          
                          
                          <div className='col-md-2'>
                            <div>
                              <label>Show All</label>
                            </div>
                            <button
                              type="button"
                              className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                              onClick={this.showAll}
                            >
                              <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Show All</button>
                          </div>

                        </div>

                      </div>
                    </div>

                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-hover`}>
                      <thead className="table-light">
                        <tr>

                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          <td>Department</td>
                          <td>Location</td>
                          <td>Shift Title</td>
                          <th className="text-center">OT Hours</th>
                         
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.rows.map((row) => {
                          let durationHours = 0;
                          return (
                            <tr key={row.employee_id}>
                              <td>{row.employee_code}</td>
                              <td> <NavLink to={`/AttendenceDashboard/${row.employee_id}`}> {row.employee_name} </NavLink> </td>
                              <td>{row.department_title}</td>
                              <td>{row.location_title}</td>
                              <td>{row.company_location_shift_name}</td>
                              <th>{row.total_ot_hrs}</th>
                              
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={18}>
                            <div className="d-flex justify-content-between">
                              <button disabled={ this.state.prev === false && this.state.loadingList === false ? true : false } type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`} >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div className="col-md-4" style={{ display: "flex", alignItems: "center" }} > { <small> Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page} </small> } </div>
                              <div className="col-md-2">
                                <select className="form-select" onChange={(e) => this.handleChange(e)} > {Array.from( { length: this.state.total_pages }, (_, i) => ( <option selected={this.state.page === i + 1} key={i} value={i + 1} > Page {i + 1} </option> ) )} </select>
                              </div>
                              <button
                                disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`} >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OTSummaryReport);
